import Store from '@/store';

const Login = () => import(/* webpackChunkName: 'SunsetAdminLogin' */ '@/SunsetAdmin/views/Login');
const Dashboard = () => import(/* webpackChunkName: 'SunsetAdminDashboard' */ '@/SunsetAdmin/views/Dashboard');
const Users = () => import(/* webpackChunkName: 'SunsetAdminUsers' */ '@/SunsetAdmin/views/Users');

export default [
  {
    path: '/sunset-admin',
    component: () => import('@/SunsetAdmin/Index'),
    meta: { auth: false }, // We handle auth ourselves
    children: [
      {
        path: '',
        redirect: { name: 'sunset-admin-login' },
      },
      {
        path: 'login',
        name: 'sunset-admin-login',
        component: Login,
      },
      {
        path: 'dashboard',
        name: 'sunset-admin-dashboard',
        component: Dashboard,
        meta: { requiresAuth: true },
        beforeEnter: (to, from, next) => {
          // Check if user is authenticated using sunset-admin store
          const isAuthenticated = Store.getters['sunsetAdmin/isAuthenticated'];
          if (isAuthenticated) {
            next();
          } else {
            next({ name: 'sunset-admin-login', replace: true });
          }
        },
      },
      {
        path: 'users',
        name: 'sunset-admin-users',
        component: Users,
        meta: { requiresAuth: true },
        beforeEnter: (to, from, next) => {
          // Check if user is authenticated using sunset-admin store
          const isAuthenticated = Store.getters['sunsetAdmin/isAuthenticated'];
          if (isAuthenticated) {
            next();
          } else {
            next({ name: 'sunset-admin-login', replace: true });
          }
        },
      },
    ],
  },
];

